import React from 'react';
import { ROLE_VALUE } from '@src/constants';
import { useSelector } from 'react-redux';
import NoPermissions from './NoPermission';

const PermissionGate = ({ requiredPermissions = [], children }) => {
  const { account } = useSelector((state) => state.auth);
  const userPermissions = account?.permissions || [];

  const isSupperAdmin = account?.roles.includes(ROLE_VALUE.SUPER_ADMIN);
  const hasPermission = requiredPermissions.some((permission) =>
    userPermissions.includes(permission),
  );
  return <>{isSupperAdmin || hasPermission ? children : <NoPermissions />}</>;
};

export default PermissionGate;
